import axios from "axios";
import { AXIOS_GET, AXIOS_POST } from "../server/api/crud";
import { BASE_URL_API } from "../constants/constants";
import { getAccesToken } from "../Localstorage/localstorage";

const buildHeaders = () => {
  const accessToken = getAccesToken();
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };
  if (accessToken) headers.Authorization = `Bearer ${accessToken}`;
  return headers;
};

export const fetchSupportTickets = async () => {
  const response = await AXIOS_GET("support/tickets");
  return response?.data?.data || [];
};

export const fetchSupportTicketById = async (ticketId) => {
  const response = await AXIOS_GET(`support/tickets/${ticketId}`);
  return response?.data?.data || { ticket: null, messages: [] };
};

export const createSupportTicket = async (payload) => {
  const response = await AXIOS_POST("support/tickets", payload);
  return response?.data?.data || { ticket: null, messages: [] };
};

export const sendSupportMessage = async (ticketId, payload) => {
  const response = await AXIOS_POST(`support/tickets/${ticketId}/messages`, payload);
  return response?.data?.data || { ticket: null, messages: [] };
};

export const markSupportTicketRead = async (ticketId) => {
  const response = await axios.patch(
    `${BASE_URL_API}/support/tickets/${ticketId}/read`,
    {},
    { headers: buildHeaders() }
  );
  return response?.data?.data || null;
};

export const updateSupportTicketStatus = async (ticketId, status) => {
  const response = await axios.patch(
    `${BASE_URL_API}/support/tickets/${ticketId}/status`,
    { status },
    { headers: buildHeaders() }
  );
  return response?.data?.data || null;
};

export const assignSupportTicketAdmin = async (ticketId, assignedAdminId) => {
  const response = await axios.patch(
    `${BASE_URL_API}/support/tickets/${ticketId}/assign`,
    { assigned_admin_id: assignedAdminId || null },
    { headers: buildHeaders() }
  );
  return response?.data?.data || null;
};
